import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import type {} from '@mui/x-date-pickers/themeAugmentation';

// A custom theme for this app
const lightThemeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#363636',
      light: '#363636',
      dark: '#191919',
      contrastText: '#FFFFFF',
      background: '#CDF6F6'
    },
    secondary: {
      main: '#89B219',
    },
    text: {
      primary: 'rgba(16,16,16,0.87)',
      secondary: 'rgba(0,0,0,0.52)',
    },
  },

  overrides: {
    MUIDataTableBodyRow: {
      root: {
        '&:nth-child(odd)': {
          backgroundColor: '#FF0000'
        }
      }
    },
  }

};

const darkThemeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#333',
      // light: '#363636',
      // dark: '#545454',
      contrastText: '#FFFFFF',
    },
    // red - #C70000, yellow - #E8AB00, orange - #FB7500, green - #7DAA00
    secondary: {
      main: '#89B219',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#89B219',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FB7500',
      contrastText: '#FFFFFF',
    },
    danger: {
      main: '#FF0000',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#868686',
      contrastText: '#000000',
    }
  },
  overrides: {
    MUIDataTableBodyRow: {
      root: {
        '&:nth-child(odd)': {
          backgroundColor: '#FF0000'
        }
      }
    },
  }

};



let theme = createTheme(darkThemeOptions);


export default theme;